var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-785 -540)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(787 544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none",
    d: "M 16 19 L 2 19 C 1.448600053787231 19 1 18.63297080993652 1 18.18181991577148 L 1 1 L 17 1 L 17 18.18181991577148 C 17 18.63297080993652 16.55139923095703 19 16 19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M 2 2 L 2 18 L 16 18 L 16 2 L 2 2 M 0 0 L 18 0 L 18 18.18181991577148 C 18 19.18597030639648 17.10457038879395 20 16 20 L 2 20 C 0.8954296112060547 20 0 19.18597030639648 0 18.18181991577148 L 0 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2px",
    transform: "translate(790 540)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "none",
    width: 12,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 10,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 22,
    height: 2,
    transform: "translate(785 544)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M-3311.946,7578.931v8",
    transform: "translate(4104.946 -7028.93)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    d: "M0,8V0",
    transform: "translate(799 550.001)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.abc39b2e.svg";
export { ForwardRef as ReactComponent };